import React, {useState} from "react";
import styled from "styled-components";
import {t} from "../../shared-services/translate";
import {currentTheme} from "../../react-themes/theme";
import useBadges from "../../react-hooks/useBadges";

const theme = currentTheme();

const CustomerBadges = (props) => {
  const [badges, isLoading] = useBadges();

  if (isLoading || !badges || badges.length === 0) {
    return null;
  }

  return (
    <StyledCustomerBadge isMobile={window.isMobile}>
      <div className='user-badges'>
        {window.isMobile
          ? <h2 className='user-badges-title'>
            {t("customer_badges.title")}
          </h2>
          : <div className='user-badges-title'>
            {t("customer_badges.title")}
          </div>
        }
        <div className='user-badges-box'>
          {badges.map((badge, index) => (
            <a key={badge.name} id={badge.class} className={`user-badge ${index ? "margin-left-5" : ""}`} href={badge.link}>
              {badge.name === "hofpass"
                ? <span className='farmy'>Farmy</span>
                : null}
              <span className='service'>
                {badge.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </StyledCustomerBadge>
  );
};

const StyledCustomerBadge = styled.div`
  .user-badges {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: ${props => props.isMobile ? "column" : "row"};
    color: ${theme.colors.farmy.grey};
      padding-right: 15px;
    h2 {
      font-variant: small-caps;
    }
    .user-badges-title {
      width: ${props => props.isMobile ? "100%" : "65px"};
      text-align: ${props => props.isMobile ? "center" : "left"};
      font-weight: ${props => props.isMobile ? 600 : 400};
      margin: ${props => props.isMobile ? "15px 0px 25px 0px" : "0px 15px 0px 0px"};
    }
    .user-badges-box {
      display: flex;
    }
    .user-badge {
      width: ${props => props.isMobile ? "110px" : "70px"};
      height: ${props => props.isMobile ? "54px" : "29px"};
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      text-align: center;
      line-height: 1;
    }
    .farmy {
      font-size: ${props => props.isMobile ? "11px" : "9px"};
      font-weight: 100;
      margin-bottom: ${props => props.isMobile ? "5px" : "2px"};
    }
    .service {
      font-size: ${props => props.isMobile ? "15px" : "11px"};
      text-transform: uppercase;
      width: 100%;
      font-weight: 900;
      line-height: ${props => props.isMobile ? "11px" : "7px"};
    }
    #badge-farmy-family {
      color: ${theme.colors.farmy.farmyFamilyBg};
      border: 1px solid ${theme.colors.farmy.farmyFamilyBg};
    }
    #badge-investor {
      color: #11401a;
      border: 1px solid #11401a;
      cursor: default;
    }
    #badge-farmypass-legacy {
      color: ${theme.colors.farmy.green};
      border: 1px solid ${theme.colors.farmy.green};
    }
    #badge-farmypass {
      color: ${theme.colors.farmy.green};
      border: 1px solid ${theme.colors.farmy.green};
    }
  }
`;

export default CustomerBadges;
